import { render } from "./BaseMessage.vue?vue&type=template&id=b45f11d8&scoped=true"
import script from "./BaseMessage.vue?vue&type=script&lang=js"
export * from "./BaseMessage.vue?vue&type=script&lang=js"

import "./BaseMessage.vue?vue&type=style&index=0&id=b45f11d8&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app-links\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b45f11d8"]])

export default __exports__